<div class="profile-page">
  <h1 class="profile-page__title">Mon profil</h1>

  <p class="profile-page__state" *ngIf="loading">Chargement du profil…</p>
  <p class="profile-page__state" *ngIf="!loading && !profile">Profil indisponible pour le moment.</p>

  <ng-container *ngIf="!loading && profile">
    <section class="profile-card">
      <div class="profile-hero">
        <div class="profile-avatar">
          <div class="profile-avatar__ring">
            <img *ngIf="photoPreview; else avatarFallback" class="profile-avatar__img" [src]="photoPreview" alt="" />
            <ng-template #avatarFallback>
              <span class="profile-avatar__initial">{{ avatarInitial }}</span>
            </ng-template>
          </div>
          <button
            class="profile-avatar__camera"
            type="button"
            [disabled]="photoBusy || savingProfile"
            aria-label="Changer la photo de profil"
            (click)="openPhotoPicker()">
            <mat-icon aria-hidden="true">photo_camera</mat-icon>
          </button>
          <input
            #photoInput
            class="profile-avatar__file"
            type="file"
            accept="image/*"
            (change)="onPhotoSelected($event)" />
        </div>

        <h2 class="profile-hero__name">{{ firstNameDisplay }}</h2>
        <p class="profile-hero__phone">{{ phoneDisplay }}</p>
      </div>

      <div class="profile-section">
        <div class="profile-section__icon" aria-hidden="true">
          <mat-icon>person_outline</mat-icon>
        </div>
        <h3 class="profile-section__title">Informations personnelles</h3>
      </div>

      <form class="profile-form" [formGroup]="form" (ngSubmit)="saveProfile()" novalidate>
        <p class="profile-banner profile-banner--error" *ngIf="profileError" role="alert">{{ profileError }}</p>
        <p class="profile-banner profile-banner--success" *ngIf="profileSuccess">{{ profileSuccess }}</p>

        <div class="field-group">
          <label class="field-label" for="profile-name">Nom</label>
          <div class="field" [class.field--invalid]="fieldInvalid('name')">
            <mat-icon class="field__icon" aria-hidden="true">person</mat-icon>
            <input id="profile-name" class="field__input" type="text" formControlName="name" placeholder="Nom" />
          </div>
          <span class="field-error" *ngIf="fieldError('name') as error">{{ error }}</span>
        </div>

        <div class="field-group">
          <label class="field-label" for="profile-first-name">Prénom</label>
          <div class="field" [class.field--invalid]="fieldInvalid('firstName')">
            <mat-icon class="field__icon" aria-hidden="true">account_circle</mat-icon>
            <input id="profile-first-name" class="field__input" type="text" formControlName="firstName" placeholder="Prénom" />
          </div>
          <span class="field-error" *ngIf="fieldError('firstName') as error">{{ error }}</span>
        </div>

        <div class="field-group">
          <label class="field-label" for="profile-address">Adresse</label>
          <div class="field field--textarea">
            <mat-icon class="field__icon" aria-hidden="true">location_on</mat-icon>
            <textarea
              id="profile-address"
              class="field__input"
              formControlName="address"
              rows="2"
              placeholder="Adresse"></textarea>
          </div>
        </div>

        <div class="field-group">
          <label class="field-label" for="profile-birth-date">Date de naissance</label>
          <div class="field" [class.field--invalid]="fieldInvalid('birthDate')">
            <mat-icon class="field__icon" aria-hidden="true">calendar_month</mat-icon>
            <input
              id="profile-birth-date"
              class="field__input"
              type="text"
              formControlName="birthDate"
              placeholder="JJ/MM/AAAA"
              inputmode="numeric" />
            <input
              #birthDateNative
              class="profile-date-native"
              type="date"
              [min]="minBirthDate"
              [max]="maxBirthDate"
              tabindex="-1"
              aria-hidden="true"
              (change)="onNativeDateChange($event)" />
            <button class="field__toggle" type="button" aria-label="Choisir une date" (click)="openDatePicker()">
              <mat-icon>event</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="fieldError('birthDate') as error">{{ error }}</span>
        </div>

        <div class="field-group">
          <label class="field-label" for="profile-niu">Numéro unique d'identification</label>
          <div class="field" [class.field--invalid]="fieldInvalid('niu')">
            <mat-icon class="field__icon" aria-hidden="true">badge</mat-icon>
            <input
              id="profile-niu"
              class="field__input"
              type="text"
              formControlName="niu"
              maxlength="14"
              placeholder="NIU (14 caractères)" />
          </div>
          <span class="field-error" *ngIf="fieldError('niu') as error">{{ error }}</span>
        </div>

        <button class="profile-submit" type="submit" [disabled]="savingProfile || photoBusy">
          <mat-icon *ngIf="!savingProfile" aria-hidden="true">save</mat-icon>
          <span class="profile-submit__spinner" *ngIf="savingProfile" aria-hidden="true"></span>
          {{ savingProfile ? 'Mise à jour...' : 'Mettre à jour le profil' }}
        </button>
      </form>
    </section>

    <section class="profile-card">
      <div class="profile-section profile-section--bank">
        <mat-icon class="profile-section__bank-icon" aria-hidden="true">account_balance</mat-icon>
        <h3 class="profile-section__title">Prélèvement bancaire</h3>
      </div>

      <p class="profile-page__state" *ngIf="banksLoading">Chargement des banques...</p>

      <div class="profile-banks-error" *ngIf="banksError && !banksLoading">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <p>Erreur de chargement des banques</p>
        <button class="profile-retry" type="button" (click)="loadBanks()">Réessayer</button>
      </div>

      <form class="profile-form" [formGroup]="bankForm" (ngSubmit)="saveBank()" novalidate *ngIf="!banksLoading">
        <p class="profile-banner profile-banner--error" *ngIf="bankError" role="alert">{{ bankError }}</p>
        <p class="profile-banner profile-banner--success" *ngIf="bankSuccess">{{ bankSuccess }}</p>

        <div class="field-group">
          <label class="field-label" for="profile-bank">Nom de la banque</label>
          <div class="field field--select" [class.field--invalid]="bankFieldInvalid('bankId')">
            <select
              id="profile-bank"
              class="field__input field__select"
              formControlName="bankId">
              <option value="">Sélectionner une banque</option>
              <option *ngFor="let bank of banks" [value]="bankCode(bank)">{{ bankLabel(bank) }}</option>
            </select>
            <mat-icon class="field__affix" aria-hidden="true">expand_more</mat-icon>
          </div>
          <span class="field-error" *ngIf="!banks.length && !banksError">Aucune banque disponible.</span>
          <span class="field-error" *ngIf="bankFieldInvalid('bankId')">La banque est obligatoire</span>
        </div>

        <div class="field-group">
          <label class="field-label" for="profile-account">Numéro de compte</label>
          <div class="field" [class.field--invalid]="bankFieldInvalid('accountNumber')">
            <input
              id="profile-account"
              class="field__input"
              type="text"
              formControlName="accountNumber"
              placeholder="Saisir le numéro de compte" />
          </div>
          <span class="field-error" *ngIf="bankFieldInvalid('accountNumber')">Le numéro de compte est obligatoire</span>
        </div>

        <button class="profile-submit" type="submit" [disabled]="savingBank">
          <mat-icon *ngIf="!savingBank" aria-hidden="true">save</mat-icon>
          <span class="profile-submit__spinner" *ngIf="savingBank" aria-hidden="true"></span>
          {{ savingBank ? 'Mise à jour en cours...' : 'Mettre à jour les infos bancaires' }}
        </button>
      </form>
    </section>
  </ng-container>
</div>
